(function (angular) {
	'use strict';

	angular
		.module('settingsModule')
		.controller('EditTrustAccount', [
			'$filter',
			'FileUploadFactory',
			'globalConfig',
			'US_STATES',
			EditTrustAccountFunction
		]);

	function EditTrustAccountFunction(
		$filter,
		FileUploadFactory,
		globalConfig,
		US_STATES
	) {
		var editTrustAccount = this;

		(function init() {
			editTrustAccount.states = US_STATES;

			angular.extend(editTrustAccount, globalConfig);

			editTrustAccount.name = angular.isDefined(editTrustAccount.serializedForm.name) ? editTrustAccount.serializedForm.name : undefined;

			editTrustAccount.trustType = $filter('filter')(editTrustAccount.trustAccountTypes, {'value': editTrustAccount.serializedForm.trustType}, true)[0];
			editTrustAccount.irrevocableTrustSubtype = $filter('filter')(editTrustAccount.irrevocableTrustSubtypes, {'value': editTrustAccount.serializedForm.irrevocableTrustSubtype}, true)[0];
			editTrustAccount.trustClassification = $filter('filter')(editTrustAccount.trustClassifications, {'value': editTrustAccount.serializedForm.trustClassification}, true)[0];
			editTrustAccount.tinType = $filter('filter')(editTrustAccount.tinTypes, {'value': editTrustAccount.serializedForm.tinType}, true)[0];
			editTrustAccount.showTinFields = !angular.isDefined(editTrustAccount.serializedForm.ein);

			editTrustAccount.state = $filter('filter')(editTrustAccount.states, {'abbreviation': editTrustAccount.serializedForm.state}, true)[0];
			editTrustAccount.registrationState = $filter('filter')(editTrustAccount.states, {'abbreviation': editTrustAccount.serializedForm.registrationState}, true)[0];

			editTrustAccount.trust = FileUploadFactory.createStateObj('IDENTIFICATION_DOCUMENT');
			editTrustAccount.resetUpload = FileUploadFactory.resetUpload;
			editTrustAccount.uploadFiles = FileUploadFactory.uploadFiles;
		})();
	}
})(window.angular);